export default "__VITE_ASSET__DmkKok7n__"